module.exports = __webpack_public_path__ + "img/vip.e812e0cb.png";